/* eslint-disable max-len */
const mockBaseListing = {
    numTotalListings: 10,
    isPartialResponse: false,
    restrictions: {
        hasListingsApplicationsRestricted: false,
    },
    listings: [],
    maintenancePartner: {
        isAvailable: false,
    },
    pager: {
        startKey: '2w5rgdnyevuwf_Postlets',
        endKey: '51vb3bhdc4jdw_Postlets',
        hasMore: false,
    },
};

const mockConnectedMF = {
    listings: [
        {
            aliasEncoded: '1535vhfp19sg2',
            listingAlias: '1535vhfp19sg2',
            feedId: 'Postlets',
            feedName: 'Zillow',
            isFeed: false,
            active: true,
            isActive: true,
            address: {
                state: 'TX',
                city: 'Fort Worth',
                zip: '76120',
                street: '9001 Randol Mill Rd',
                unit: '',
            },
            isMultifamily: true,
            name: 'animal',
            panels: [
                {
                    id: 'messages',
                    title: 'Messages',
                    message: 'View inquiries from renters',
                    urlPath: '/rental-manager/inbox/3hwekszrum921_Postlets?byProperty=true&itc=ZRM_PropertyCard_Click',
                    isDisabled: false,
                },
                {
                    id: 'analytics',
                    title: 'Analytics',
                    message: "Measure your listing's performance",
                    urlPath: '/rental-manager/properties/3hwekszrum921_Postlets/analytics?itc=ZRM_PropertyCard_Click',
                    isDisabled: false,
                },
                {
                    id: 'reviews',
                    title: 'Reviews',
                    message: 'Read and respond to renter feedback',
                    urlPath: '/rental-manager/properties/3hwekszrum921_Postlets/reviews?itc=ZRM_PropertyCard_Click',
                    isDisabled: false,
                },
            ],
            photoUrl: 'https://photosdevnet.hotpads.com/photos/cc00759c-f6bf-11ea-9f4f-0242ac12002a.jpg',
            status: {
                code: 'active',
                message: 'For rent',
            },
            productTypes: [],
            hasBoost: false,
            isArchived: false,
            isConnectedExperience: false,
        },
    ],
};

const mockConnectedSF = {
    listings: [
        {
            aliasEncoded: '275ujabpfvpty',
            listingAlias: '275ujabpfvpty',
            feedId: 'Postlets',
            feedName: 'Zillow',
            isFeed: false,
            active: true,
            isActive: true,
            address: {
                state: 'OR',
                city: 'Bend',
                zip: '97702',
                street: '20075 Alderwood Cir',
                unit: '',
            },
            isMultifamily: false,
            name: 'impetus',
            panels: [
                {
                    id: 'findTenants',
                    title: 'Find tenants',
                    subtitle: 'Listing, inquiries, applications',
                    message: 'Screen tenants online',
                    urlPath: '/rental-manager/properties/275ujabpfvpty/find-tenants?itc=ZRM_PropertyCard_Click',
                    isDisabled: false,
                },
                {
                    id: 'manageTenants',
                    title: 'Manage tenants',
                    subtitle: 'Leases, payments',
                    message: 'Create or upload your own lease',
                    urlPath: '/rental-manager/properties/275ujabpfvpty/manage-tenants?itc=ZRM_PropertyCard_Click',
                    isDisabled: false,
                },
            ],
            photoUrl: 'https://photosdevnet.hotpads.com/photos/cc00759c-f6bf-11ea-9f4f-0242ac12002a.jpg',
            status: {
                code: 'active',
                message: 'Listed for 2 days',
            },
            productTypes: [],
            hasBoost: false,
            isArchived: false,
            isConnectedExperience: true,
        },
        {
            aliasEncoded: '4t2g0dy9zhjfv',
            listingAlias: '4t2g0dy9zhjfv',
            feedId: 'HomeRentals',
            feedName: 'HomeRentals',
            isFeed: true,
            active: true,
            isActive: true,
            address: {
                state: 'AZ',
                city: 'Mesa',
                zip: '85210',
                street: '422 Declined St',
                unit: 'E',
            },
            isMultifamily: false,
            name: '2 bed, 1.0 bath, 650 sqft, $950',
            panels: [
                {
                    id: 'findTenants',
                    title: 'Find tenants',
                    subtitle: 'Listing, inquiries, applications',
                    message: 'Screen tenants online',
                    urlPath: '/rental-manager/properties/4t2g0dy9zhjfv/find-tenants?itc=ZRM_PropertyCard_Click',
                    isDisabled: false,
                },
                {
                    id: 'manageTenants',
                    title: 'Manage tenants',
                    subtitle: 'Leases, payments',
                    message: 'Create or upload your own lease',
                    urlPath: '/rental-manager/properties/4t2g0dy9zhjfv/manage-tenants?itc=ZRM_PropertyCard_Click',
                    isDisabled: false,
                },
            ],
            photoUrl: 'https://photosdevnet.hotpads.com/search/listingPhoto/HomeRentals/AZ0145299L/0000_930724377_medium.jpg',
            status: {
                code: 'declined',
                message: 'Listing declined',
            },
            productTypes: [],
            hasBoost: false,
            isArchived: false,
            isConnectedExperience: true,
        },
    ],
};

const mockNotConnectedSF = {
    listings: [
        {
            aliasEncoded: '275ujabpfvpty',
            listingAlias: '275ujabpfvpty',
            feedId: 'Postlets',
            feedName: 'Zillow',
            isFeed: false,
            active: false,
            isActive: false,
            address: {
                state: 'OR',
                city: 'Bend',
                zip: '97702',
                street: '20075 Alderwood Cir',
                unit: 'NC',
            },
            isMultifamily: false,
            name: 'impetus',
            panels: [
                {
                    id: 'applications',
                    title: 'Applications',
                    message: 'Screen tenants online',
                    urlPath: '/rental-manager/applications?propertyId=275ujabpfvpty&itc=ZRM_PropertyCard_Click',
                    isDisabled: false,
                },
                {
                    id: 'leases',
                    title: 'Leases',
                    message: 'Create or upload your own lease',
                    urlPath: '/rental-manager/leasing/property/275ujabpfvpty?itc=ZRM_PropertyCard_Click',
                    isDisabled: true,
                },
                {
                    id: 'payments',
                    title: 'Payments',
                    message: 'Set up online payments',
                    urlPath: '/rental-manager/payments/properties/275ujabpfvpty?itc=ZRM_PropertyCard_Click',
                    isDisabled: false,
                },
            ],
            photoUrl: 'https://photosdevnet.hotpads.com/photos/cc00759c-f6bf-11ea-9f4f-0242ac12002a.jpg',
            status: {
                code: 'inactive',
                message: 'Off-market',
            },
            productTypes: [],
            hasBoost: false,
            isArchived: false,
            isConnectedExperience: false,
        },
    ],
};

export {
    mockBaseListing,
    mockConnectedMF,
    mockConnectedSF,
    mockNotConnectedSF,
};
